import { render, staticRenderFns } from "./WidgetProjectSelect.vue?vue&type=template&id=5d5af994&scoped=true"
import script from "./WidgetProjectSelect.vue?vue&type=script&lang=js"
export * from "./WidgetProjectSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5af994",
  null
  
)

export default component.exports